<template>
    <div class="searchBar search__grid--fullLength">
        <div
            id="searchbar"
            role="search">
            <div class="searchbar__grid searchBar__focus">
                <div class="searchBar__input searchBar__input--mobile">
                    <svg
                        v-if="!isMobile"
                        class="text-color--gray-blue searchIcon__left"
                        height="16"
                        width="16"
                        aria-hidden="true">
                        <use href="#iconMagnifyingGlassRegular" />
                    </svg>

                    <search-autocomplete class="searchbar__autocomplete searchBar__rebrushInput" />

                    <button
                        type="button"
                        data-content
                        :name="trans('SEARCH')"
                        class="button button--primary searchBar__button hideOnMobile"
                        data-gtm="search__refreshButton"
                        :aria-label="trans('SEARCH_REFRESH')"
                        @click.stop.prevent="startSearch">
                        <span> {{ trans('SEARCH') }} </span>
                    </button>
                </div>
                <button
                    type="button"
                    data-content
                    :name="trans('SEARCH')"
                    class="button button--primary search__icon__button searchBar__buttonIcon hideOnDesktop"
                    data-gtm="search__refreshButton"
                    :aria-label="trans('SEARCH_REFRESH')"
                    @click.stop.prevent="startSearch">
                    <svg
                        class="homeSearch__submitIcon padding-left-0"
                        height="15"
                        width="15"
                        aria-hidden="true">
                        <use href="#iconMagnifyingGlassBold" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import { useGetters, useActions } from 'composables/useVuex';
    import Translator from 'tools/trans';
    import SearchAutocomplete from './components/searchAutocompleteResult';
    import { isMobile } from 'tools/isMobile';
    import { statHistoryCache } from 'tools/historycache';
    import { pushToDataLayer } from 'search/dataLayer';

    export default defineComponent({
        name: 'SearchBar',
        components: {
            SearchAutocomplete,
        },
        props: {
            sortMethod: { type: String, default: null },
        },
        data() {
            return {
                isMobile: isMobile(),
            };
        },
        setup() {
            const userId = window.stGlobals.userId;
            const historycache = statHistoryCache();
            const historyLimit = 10;

            const getters = {
                ...useGetters('search', [ 'query', 'entry', 'entryUniqueId', 'totalFound' ]),
            };

            const actions = {
                ...useActions('search', ['setShow', 'setParamFunc', 'startSearch', 'resetPageNumber', 'resetFilters', 'resetTagsPage']),
            };

            async function startSearch() {
                actions.setShow(false);
                // await actions.setValue( { value: searchValue.value } );
                await actions.resetPageNumber();
                await actions.setParamFunc();
                await actions.resetTagsPage();
                await actions.startSearch({ noFigures: false, noReport: false, noTopic: false, resetTags: true, history: false });
                // call push to data layer
                setTimeout(() => {
                    pushToDataLayer();
                }, 5000);
                if (userId) {
                    historycache.addEntry(
                        userId,
                        getters.entryUniqueId.value,
                        getters.entry.value,
                        'searchhistory',
                        historyLimit
                    );
                }
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE
            }


            function openLink(uri) {
                const url = new URL(location);
                url.pathname = uri;
                history.go(url);
            }

            // get query search paramter
            return {
                trans: Translator.trans,
                startSearch,
                openLink,
                ...getters,
            };
        },
    });
</script>
